export const tiposServicosUtils = () => {


    return [
        {
            id: 1,
            nome: 'Hospedagem',
            backgroundcolor: '#0dcaf0',
            color: '#FFF',
            value: false

        }, {
            id: 2,
            nome: 'Petsitter',
            color: '',
            value: false
        }, {
            id: 3,
            nome: 'Taxi dog',
            color: '',
            value: false
        },
        /*{
            id: 4,
            nome: 'Clínica',
            color:''
        },*/
    ]
}